import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Card, Button, Form, Tabs, Tab, Badge } from 'react-bootstrap';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./LeadDetails.css";
import ReactQuill from "react-quill";
import Navbar from "../../../Shared/ManagerNavbar/Navbar";
import { baseURL } from "../../../Apiservices/Api";
import { FaCopy, FaCheck, FaTimes, FaTrash } from "react-icons/fa";
import axios from "axios";
import { ThemeContext } from "../../../Shared/Themes/ThemeContext";
import { AuthContext } from '../../../AuthContext/AuthContext';
import { adminMail } from '../../../Apiservices/Api';

const LeadOppView = () => {
  const { userEmail, userId, userName } = useContext(AuthContext);
  console.log("🔥 userId:", userId); 
  console.log("🔥 userEmail:", userEmail);
  const [collapsed, setCollapsed] = useState(false);
  const [lead, setLead] = useState(null);
  const [message, setMessage] = useState("");
  const [newComment, setNewComment] = useState("");
  const { themeColor } = useContext(ThemeContext);
  const [loading, setLoading] = useState(false);
  const [groupedEmailHistory, setGroupedEmailHistory] = useState([]);
  const [text, setText] = useState("");
  const [availableTags, setAvailableTags] = useState([]);
  const [selectedTagId, setSelectedTagId] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [customerTags, setCustomerTags] = useState([]);
  const [reminderHistory, setReminderHistory] = useState([]);
      const [templates, setTemplates] = useState([]);
  const [showTemplates, setShowTemplates] = useState(false);
  
  // Get leadid from params or location state FIRST
  const { leadid: paramLeadId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const leadid = paramLeadId || (location.state && location.state.leadid) || null;
  
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [receiverEmails, setReceiverEmails] = useState("");
  const [assignedSalesId, setAssignedSalesId] = useState(null);
  const [ccEmails, setCcEmails] = useState("");
  const [bccEmails, setBccEmails] = useState("");
  const [showCC, setShowCC] = useState(false);
  const [showBCC, setShowBCC] = useState(false);
  const [formData, setFormData] = useState({
    reminder_setting: "",
    notes: "",
  });

  // Fetch assigned sales id for the lead
  useEffect(() => {
    const fetchLeadDetails = async () => {
      try {
        const leadResponse = await axios.get(`${baseURL}/api/leads/${leadid}`);
        setAssignedSalesId(leadResponse.data.assignedSalesId);
      } catch (error) {
        console.error("Error fetching lead details:", error);
      }
    };
    if (leadid) {
      fetchLeadDetails();
    }
  }, [leadid]);

       useEffect(() => {
  const fetchTemplates = async () => {
    try {
      const res = await axios.get(`${baseURL}/api/opp-templates`);
      setTemplates(res.data);
    } catch (err) {
      console.error("Error fetching templates", err);
    }
  };

  fetchTemplates();
}, []);

  // Fetch all available tags
  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/tags`);
        setAvailableTags(response.data);
      } catch (error) {
        console.error("Error fetching tags:", error);
      }
    };
    fetchTags();
  }, []);

  // Fetch reminder history when lead is loaded
  useEffect(() => {
    if (lead?.lead?.leadid) {
      fetchReminderHistory(lead.lead.leadid);
    }
  }, [lead]);

  // Fetch customer tags when lead details are loaded
  useEffect(() => {
    if (lead?.lead?.customerid) {
      fetchCustomerTags(lead.lead.customerid);
    }
  }, [lead]);

  const fetchCustomerTags = async (customerId) => {
    try {
      const response = await axios.get(`${baseURL}/api/customers/${customerId}`);
      let tags = [];
      if (response.data.tags) {
        if (Array.isArray(response.data.tags)) {
          tags = response.data.tags;
        } else if (typeof response.data.tags === 'string') {
          try {
            const parsedTags = JSON.parse(response.data.tags);
            if (Array.isArray(parsedTags)) {
              if (parsedTags.length > 0 && typeof parsedTags[0] === 'number') {
                const tagResponse = await axios.get(`${baseURL}/api/tags`);
                tags = tagResponse.data.filter(tag => 
                  parsedTags.includes(tag.id)
                );
              } else {
                tags = parsedTags;
              }
            }
          } catch (e) {
            console.error("Error parsing tags:", e);
          }
        }
      }
      setCustomerTags(tags);
    } catch (error) {
      console.error("Error fetching customer tags:", error);
    }
  };

  const handleTagChange = (event) => {
    setSelectedTagId(event.target.value);
  };

  const addTag = async () => {
    if (!selectedTagId || !lead?.lead?.customerid) return;

    setIsUpdating(true);
    setMessage("");

    try {
      const currentTagIds = customerTags ? customerTags.map(tag => tag.id) : [];
      
      if (!currentTagIds.includes(parseInt(selectedTagId))) {
        const updatedTagIds = [...currentTagIds, parseInt(selectedTagId)];
        
        const response = await axios.put(
          `${baseURL}/api/customers/${lead.lead.customerid}/tags`,
          { tagIds: updatedTagIds }
        );
        
        setCustomerTags(response.data.tags);
        setMessage("Tag added successfully!");
      } else {
        setMessage("Tag already exists!");
      }
    } catch (error) {
      console.error("Error adding tag:", error);
      setMessage("Failed to add tag. " + (error.response?.data?.error || ""));
    } finally {
      setIsUpdating(false);
      setSelectedTagId("");
    }
  };

  const removeTag = async (tagIdToRemove) => {
    if (!lead?.lead?.customerid) return;

    setIsUpdating(true);
    setMessage("");

    try {
      const updatedTagIds = customerTags
        .filter(tag => tag.id !== tagIdToRemove)
        .map(tag => tag.id);
      
      const response = await axios.put(
        `${baseURL}/api/customers/${lead.lead.customerid}/tags`,
        { tagIds: updatedTagIds }
      );
      
      setCustomerTags(response.data.tags);
      setMessage("Tag removed successfully!");
    } catch (error) {
      console.error("Error removing tag:", error);
      setMessage("Failed to remove tag.");
    } finally {
      setIsUpdating(false);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setMessage("Copied to clipboard!");
      setTimeout(() => setMessage(""), 1000);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.reminder_setting && !formData.notes.trim()) {
      alert("Please fill in at least Reminder Setting or Notes.");
      return;
    }

    try {
      let reminderValue = null;
      if (formData.reminder_setting) {
        const localDate = new Date(formData.reminder_setting);
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, "0");
        const day = String(localDate.getDate()).padStart(2, "0");
        const hours = String(localDate.getHours()).padStart(2, "0");
        const minutes = String(localDate.getMinutes()).padStart(2, "0");
        const seconds = "00";
        reminderValue = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }

      const payload = {
      notes: formData.notes.trim() || null,
      userId: userId,
      leadId: lead.lead.leadid,
      reminder_setting: reminderValue,
    };
      console.log("Sending payload:", payload);

      const response = await fetch(
        `${baseURL}/api/travelopportunity-setting/${lead.travelOpportunities[0].id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();
      if (response.ok) {
        alert("Reminder & Notes updated successfully!");
        fetchLeadDetails();
        fetchReminderHistory(lead.lead.leadid);
        setFormData({ reminder_setting: "", notes: "" });
      } else {
        alert("Update failed: " + result.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Something went wrong!");
    }
  };

  // Validate leadid
  useEffect(() => {
    if (!leadid) {
      console.error("Invalid Lead ID: Redirecting...");
      navigate("/not-found");
    }
  }, [leadid, navigate]);

  useEffect(() => {
    if (!leadid) return;
    fetchLeadDetails();
  }, [leadid]);

  const fetchLeadDetails = async () => {
    try {
      const response = await fetch(`${baseURL}/api/leadsoppcomment/${leadid}`);
      if (!response.ok) {
        console.error("Lead not found, status:", response.status);
        navigate("/not-found");
        return;
      }

      const data = await response.json();
      if (!data || !data.lead) {
        navigate("/not-found");
        return;
      }

      setLead(data);
      if (data.lead.email) {
        setEmail(data.lead.email);
        setReceiverEmails(data.lead.email);
      }

      fetchEmailHistory(leadid);
    } catch (error) {
      console.error("Error fetching lead details:", error);
    }
  };

  const handleDeleteReminder = async (reminderId, leadId) => {
    if (!reminderId) {
      alert("Invalid reminder ID");
      return;
    }

    const confirmDelete = window.confirm("Are you sure you want to delete this reminder?");
    if (!confirmDelete) return;

    try {
      const response = await axios.delete(`${baseURL}/reminder_settinglead/${leadId}/${reminderId}/${userId}`);
      
      if (response.status === 200) {
        alert("Reminder deleted successfully!");
        fetchReminderHistory(leadId);
      }
    } catch (error) {
      console.error("Error deleting reminder:", error);
      if (error.response?.status === 404) {
        alert("Reminder not found or you are not authorized to delete it");
      } else {
        alert("Failed to delete reminder. Please try again.");
      }
    }
  };

  const fetchEmailHistory = async (leadid) => {
    try {
      if (!leadid) {
        console.error("Lead ID is required");
        return;
      }

      const response = await axios.get(`${baseURL}/api/email-history`, {
        params: { leadid }
      });

      const sortedEmails = response.data.sort((a, b) =>
        new Date(a.created_at) - new Date(b.created_at)
      );

      const groupedEmails = [];
      let currentGroup = null;

      sortedEmails.forEach((email) => {
        if (email.type === "sent") {
          if (currentGroup &&
            Math.abs(new Date(email.created_at) - new Date(currentGroup.created_at)) < 60000 &&
            email.subject === currentGroup.subject &&
            email.text === currentGroup.text) {
            currentGroup.recipients.push(email.receiver_email);
            if (new Date(email.created_at) < new Date(currentGroup.created_at)) {
              currentGroup.created_at = email.created_at;
            }
          } else {
            if (currentGroup) groupedEmails.push(currentGroup);
            currentGroup = {
              ...email,
              recipients: [email.receiver_email],
              isGrouped: true,
              id: email.id
            };
          }
        } else {
          if (currentGroup) {
            groupedEmails.push(currentGroup);
            currentGroup = null;
          }
          groupedEmails.push({
            ...email,
            isGrouped: false
          });
        }
      });

      if (currentGroup) groupedEmails.push(currentGroup);
      setGroupedEmailHistory(groupedEmails);
    } catch (error) {
      console.error("Error fetching email history:", error);
    }
  };

  const addComment = async () => {
    if (!newComment.trim()) return;
    if (!leadid) {
      console.error("Cannot add comment: Lead ID is missing");
      return;
    }

    const trimmedComment = newComment.trim();
    const commentName = `${userName} (Manager)`;

    const comment = {
      name: commentName,
      leadid: leadid,
      timestamp: new Date().toISOString(),
      text: trimmedComment,
      notificationmessage: `${commentName}: ${trimmedComment}`,
      userId: assignedSalesId,
      email: `${adminMail}`,
    };

    try {
      const response = await fetch(`${baseURL}/comments/add`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(comment),
      });

      if (!response.ok) {
        throw new Error("Failed to add comment");
      }

      const savedComment = await response.json();
      setLead((prevLead) => ({
        ...prevLead,
        comments: [...(prevLead?.comments || []), savedComment],
      }));
      setNewComment("");
    } catch (error) {
      console.error("Error adding comment:", error);
    }
  };

  const handleEdit = (leadId) => {
    if (!leadId) {
      console.error("Lead ID is missing, cannot edit.");
      return;
    }
    navigate(`/m-edit-opportunity/${leadId}`, { state: { leadid: leadId } });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.size > 2 * 1024 * 1024) {
      alert("File size must be below 2MB.");
      return;
    }
    setSelectedFile(file);
  };

  const handleSendEmail = async () => {
    if (!text && !selectedFile) {
      alert("Please enter a message or upload a file.");
      return;
    }

    const receivers = receiverEmails.split(",").map(email => email.trim()).filter(Boolean);
    if (receivers.length === 0) {
      alert("Please enter at least one recipient email.");
      return;
    }
    const cc = showCC ? ccEmails.split(",").map(email => email.trim()).filter(Boolean) : [];
    const bcc = showBCC ? bccEmails.split(",").map(email => email.trim()).filter(Boolean) : [];

    setLoading(true);
    const formData = new FormData();
    formData.append("leadid", leadid);
    formData.append("sender_email", userEmail);
    formData.append("text", text);
    formData.append("subject", subject || "New Message");
    formData.append("type", "sent");
    formData.append("is_plain_text", "false");
    formData.append("receiver_emails", JSON.stringify(receivers));
    if (showCC) formData.append("cc_emails", JSON.stringify(cc));
    if (showBCC) formData.append("bcc_emails", JSON.stringify(bcc));

    if (selectedFile) {
      formData.append("file", selectedFile);
    }

    try {
      await axios.post(`${baseURL}/api/send-bulk-emails`, formData);
      alert("Emails sent successfully!");
      setText("");
      setSubject("");
      setSelectedFile(null);
      setCcEmails("");
      setBccEmails("");
      fetchEmailHistory(leadid);
    } catch (error) {
      console.error("Error sending bulk emails:", error);
      alert("Failed to send bulk emails.");
    }

    setLoading(false);
  };

  const fetchReminderHistory = async (leadId) => {
    try {
      const response = await axios.get(`${baseURL}/reminder_settinglead/${leadId}`);
      console.log("Fetched reminder history with action column:", response.data);
      setReminderHistory(response.data);
    } catch (error) {
      console.error("Error fetching reminder history:", error);
      if (error.response?.status !== 404) {
        setMessage("Failed to load reminder history");
      }
    }
  };

  if (!lead) return <div>Loading...</div>;

  const sortedComments = lead.comments
    ? lead.comments.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
    : [];

  const cleanEmailText = (text) => {
    if (!text) return "";
    const cleanedText = text.split(/\n?On\s.+\s(?:at|wrote:)/i)[0];
    return cleanedText.replace(/--\sThis email has been checked for viruses.*/is, "").trim();
  };

const handleTemplateCopy = (template) => {
  let formatted = `*${template.title}*\n\n${template.body}`;

  // ✅ Dynamic replacements using lead.lead values
  formatted = formatted
    .replace(/{name}/g, lead?.lead?.name || "")
    .replace(/{email}/g, lead?.lead?.email || "")
    .replace(/{phone}/g, lead?.lead?.phone_number || "")
    .replace(/{leadid}/g, lead?.lead?.leadid || "")
    .replace(/{destination}/g, lead?.lead?.destination || "")
    .replace(/{city}/g, lead?.lead?.origincity || "");

  navigator.clipboard.writeText(formatted);

  setMessage("Template copied successfully!");
  setTimeout(() => setMessage(""), 1500);

  setShowTemplates(false);
};

  return (
    <div className="salesViewLeadsContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`salesViewLeads ${collapsed ? "collapsed" : ""}`}>
        <div className="lead-opportunity-view">
          <Card className="mb-4">
            <Card.Header
              className="s-LeadOppView-modal-header"
              style={{ "--theme-color": themeColor }}
            >
              <h2>Customer and Opportunity Details</h2>
            </Card.Header>
            <Card.Body>
              {message && <div className="alert alert-info">{message}</div>}
              <Row>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <h5>Customer Details</h5>
                      <p>
                        <strong>Opp Id:</strong> {lead.lead.leadid || "N/A"}
                      </p>
                      <p>
                        <strong>Name:</strong> {lead.lead.name || "N/A"}
                      </p>
                     <p
                      style={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        marginBottom: "12px",
                      }}
                    >
                      <strong style={{ marginRight: "5px" }}>Phone Number:</strong>
                    
                      {/* WhatsApp Link */}
                      <a
                        href={`https://wa.me/${lead.lead.country_code}${lead.lead.phone_number}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          textDecoration: "none",
                          color: "blue",
                          marginRight: "10px",
                        }}
                      >
                        {lead.lead.country_code} {lead.lead.phone_number || "N/A"}
                      </a>
                    
                      {/* Copy Phone */}
                      <FaCopy
                        style={{
                          marginRight: "10px",
                          cursor: "pointer",
                          color: "#ff9966",
                        }}
                        onClick={() =>
                          copyToClipboard(
                            `${lead.lead.country_code}${lead.lead.phone_number}`
                          )
                        }
                        title="Copy Phone Number"
                      />
                    
                      {/* 🔥 Templates Button */}
                      <button
                        className="btn btn-sm btn-outline-success"
                        onClick={() => setShowTemplates(!showTemplates)}
                      >
                        Templates
                      </button>
                    
                      {/* 🔥 Templates Dropdown */}
                      {showTemplates && (
                        <div
                          style={{
                            position: "absolute",
                            top: "35px",
                            left: "110px",
                            width: "320px",
                            maxHeight: "250px",
                            overflowY: "auto",
                            background: "#fff",
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                            zIndex: 1000,
                            padding: "10px",
                          }}
                        >
                          <strong>Select Template</strong>
                    
                          {templates.length > 0 ? (
                            templates.map((t) => {
                              let preview = t.body
                                .replace(/{name}/g, lead.lead.name || "")
                                .replace(/{email}/g, lead.lead.email || "")
                                .replace(/{phone}/g, lead.lead.phone_number || "")
                                .replace(/{leadid}/g, lead.lead.leadid || "")
                                .replace(
                                  /{destination}/g,
                                  lead.lead.destination || ""
                                )
                                .replace(
                                  /{city}/g,
                                  lead.lead.origincity || ""
                                );
                    
                              return (
                                <div
                                  key={t.id}
                                  title={preview}
                                  style={{
                                    padding: "8px",
                                    borderBottom: "1px solid #eee",
                                    cursor: "pointer",
                                    transition: "0.2s",
                                  }}
                                  onClick={() => handleTemplateCopy(t)}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.background = "#f5f5f5")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.background = "#fff")
                                  }
                                >
                                  <b>{t.title}</b>
                    
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#555",
                                    }}
                                  >
                                    {preview.length > 40
                                      ? preview.slice(0, 40) + "..."
                                      : preview}
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <p>No templates found</p>
                          )}
                        </div>
                      )}
                    </p>
                      <p>
                        <strong>Email ID:</strong> {lead.lead.email || "N/A"}
                        <FaCopy
                          style={{
                            marginLeft: "8px",
                            cursor: "pointer",
                            color: "#ff9966",
                          }}
                          onClick={() => copyToClipboard(lead.lead.email)}
                          title="Copy Email"
                        />
                      </p>
                      <p>
                        <strong>Primary Source:</strong>{" "}
                        {lead.lead.primarySource || "N/A"}
                      </p>
                    </Col>
                    <Col md={6}>
                      <h5>&nbsp;</h5>
                      <p>
                        <strong>Secondary Source:</strong>{" "}
                        {lead.lead.secondarysource || "N/A"}
                      </p>
                      <p>
                        <strong>Primary Status:</strong>{" "}
                        {lead.lead.opportunity_status1 || "N/A"}
                      </p>
                      <p>
                        <strong>Secondary Status:</strong>{" "}
                        {lead.lead.opportunity_status2 || "N/A"}
                      </p>
                      <p>
                        <strong>Travel Type:</strong>{" "}
                        {lead.lead.travel_type || "N/A"}
                      </p>
                      <p>
                        <strong>Channel:</strong> {lead.lead.channel || "N/A"}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div style={{ marginBottom: '20px' }}>
                        <strong style={{ fontSize: '16px' }}>Tags:</strong>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '10px' }}>
                          {customerTags && customerTags.length > 0 ? (
                            customerTags.map((tag) => (
                              <Badge 
                                key={tag.id} 
                                bg="secondary" 
                                style={{ 
                                  display: 'flex', 
                                  alignItems: 'center',
                                  padding: '8px 12px',
                                  fontSize: '14px',
                                  borderRadius: '12px',
                                  height: '32px'
                                }}
                              >
                                {tag.label}
                                <FaTimes 
                                  style={{ 
                                    marginLeft: '8px', 
                                    cursor: 'pointer',
                                    fontSize: '14px'
                                  }} 
                                  onClick={() => removeTag(tag.id)}
                                  title="Remove tag"
                                />
                              </Badge>
                            ))
                          ) : (
                            <span style={{ fontSize: '14px' }}>No tags</span>
                          )}
                        </div>
                      </div>
                      <div style={{ 
                        display: "flex", 
                        alignItems: "center", 
                        gap: "12px",
                        marginTop: '15px'
                      }}>
                        <strong style={{ fontSize: '16px' }}>Add Tag:</strong>
                        <select
                          value={selectedTagId}
                          onChange={handleTagChange}
                          style={{ 
                            width: "50%", 
                            padding: "8px 12px",
                            fontSize: '14px',
                            borderRadius: '6px',
                            border: '1px solid #ccc'
                          }}
                        >
                          <option value="">Select a tag</option>
                          {availableTags.map((tag) => {
                            const isAlreadySelected = customerTags?.some(t => t.id === tag.id);
                            if (!isAlreadySelected) {
                              return (
                                <option key={tag.id} value={tag.id}>
                                  {tag.label}
                                </option>
                              );
                            }
                            return null;
                          })}
                        </select>
                        <FaCheck
                          onClick={addTag}
                          style={{
                            cursor: "pointer",
                            color: "green",
                            fontSize: "20px",
                            marginLeft: '5px'
                          }}
                          title="Add Tag"
                        />
                      </div>
                    </Col>
                  </Row>
                  <hr />

                  <h5>Opportunity Details</h5>
                  {lead.travelOpportunities &&
                    lead.travelOpportunities.length > 0 && (
                      <Row>
                        <Col md={6}>
                          <p>
                            <strong>Origin City:</strong>{" "}
                            {lead.travelOpportunities[0].origincity || "N/A"}
                          </p>
                          <p>
                            <strong>Destination:</strong>{" "}
                            {lead.travelOpportunities[0].destination || "N/A"}
                          </p>
                          <p>
                            <strong>Start Date:</strong>{" "}
                            {lead.travelOpportunities[0].start_date
                              ? new Date(
                                lead.travelOpportunities[0].start_date
                              ).toLocaleDateString("en-IN", {
                                timeZone: "Asia/Kolkata",
                              })
                              : "N/A"}
                          </p>
                          <p>
                            <strong>End Date:</strong>{" "}
                            {lead.travelOpportunities[0].end_date
                              ? new Date(
                                lead.travelOpportunities[0].end_date
                              ).toLocaleDateString("en-IN", {
                                timeZone: "Asia/Kolkata",
                              })
                              : "N/A"}
                          </p>
                          <p>
                            <strong>Duration:</strong>{" "}
                            {lead.travelOpportunities[0].duration || "N/A"}
                          </p>
                        </Col>
                        <Col md={6}>
                          <p>
                            <strong>Number of Adults:</strong>{" "}
                            {lead.travelOpportunities[0].adults_count || "N/A"}
                          </p>
                          <p>
                            <strong>Number of Children:</strong>{" "}
                            {lead.travelOpportunities[0].children_count || "N/A"}
                          </p>
                          <p>
                            <strong>Child Age:</strong>{" "}
                            {lead.travelOpportunities[0].child_ages || "N/A"}
                          </p>
                          <p>
                            <strong>Approx Budget:</strong>&nbsp;Rs{" "}
                            {lead.travelOpportunities[0].approx_budget || "N/A"}
                          </p>
                          <p>
                            <strong>Reminder Setting:</strong>{" "}
                            {lead.travelOpportunities[0].reminder_setting
                              ? new Date(
                                lead.travelOpportunities[0].reminder_setting
                              ).toLocaleString("en-IN", {
                                timeZone: "Asia/Kolkata"
                              })
                              : "N/A"}
                          </p>
                          <p>
                            <strong>Created Date:</strong>{" "}
                            {lead.travelOpportunities[0].created_at
                              ? new Date(
                                lead.travelOpportunities[0].created_at
                              ).toLocaleString("en-IN", {
                                timeZone: "Asia/Kolkata",
                              })
                              : "N/A"}
                          </p>
                        </Col>
                      </Row>
                    )}

                  <h5>Additional Details</h5>
                  <p>
                    <strong>Description:</strong>
                  </p>
                  <div className="s-Opp-Commentsection">
                    {lead.travelOpportunities &&
                      lead.travelOpportunities.length > 0 && (
                        <>
                          <p style={{ whiteSpace: "pre-line" }}>
                            {lead.travelOpportunities[0].description || "N/A"}
                          </p>
                        </>
                      )}
                  </div>
                  <p>
                    <strong>Notes:</strong>
                  </p>
                  <div className="s-Opp-Commentsection">
                    {lead.travelOpportunities &&
                      lead.travelOpportunities.length > 0 && (
                        <>
                          <p style={{ whiteSpace: "pre-line" }}>
                            {lead.travelOpportunities[0].notes || "N/A"}
                          </p>
                        </>
                      )}
                  </div>
                </Col>

                <Col md={6}>
                  <Tabs
                    defaultActiveKey="comments"
                    id="comment-email-tabs"
                    className="mb-3"
                    onSelect={(key) => {
                      if (key === 'email' && leadid) {
                        fetchEmailHistory(leadid);
                      }
                    }}
                  >
                    <Tab eventKey="comments" title="Comments">
                      <div className="comment-section-container">
                        <p><strong>Comments:</strong></p>
                        <div className="comment-input-container">
                          <Form.Group>
                            <Form.Label><strong>Add a New Comment</strong></Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={4}
                              placeholder="Write your comment here..."
                              value={newComment}
                              onChange={(e) => setNewComment(e.target.value)}
                              autoFocus
                            />
                            <Button
                              className="mt-2 btn-warning text-white"
                              onClick={addComment}
                              disabled={!newComment.trim()}
                            >
                              Add Comment
                            </Button>
                          </Form.Group>
                        </div>
                        <div
                          className="comment-list"
                          style={{
                            maxHeight: "300px",
                            overflowY: "auto",
                            border: "1px solid #ddd",
                            padding: "10px",
                            borderRadius: "5px",
                            marginTop: "15px",
                            backgroundColor: "#f1f7ff",
                          }}
                        >
                          {sortedComments.length > 0 ? (
                            sortedComments.map((comment) => (
                              <div key={comment.id} className="comment-item">
                                <p className="comment-timestamp">
                                  {new Date(comment.timestamp).toLocaleString("en-IN", {
                                    timeZone: "Asia/Kolkata",
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                    hour12: true,
                                  })}
                                </p>
                                <p className="comment-text">
                                  <strong>{comment.name}</strong>:{" "}
                                  <span style={{ whiteSpace: "pre-line" }}>{comment.text}</span>
                                </p>
                                <hr />
                              </div>
                            ))
                          ) : (
                            <p>No comments available.</p>
                          )}
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="email" title="Email History">
                      <div className="comment-section-container">
                        <p><strong>Email History:</strong></p>
                        {groupedEmailHistory.length > 0 ? (
                          <div className="email-history-list" style={{
                            maxHeight: "300px",
                            overflowY: "auto",
                            padding: "10px",
                            borderRadius: "5px",
                            marginTop: "15px",
                            backgroundColor: "#f1f7ff",
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px"
                          }}>
                            {groupedEmailHistory.map((emailItem) => (
                              <div 
                                key={`${emailItem.id}_${emailItem.created_at}`} 
                                style={{
                                  display: "flex",
                                  justifyContent: emailItem.type === "sent" ? "flex-end" : "flex-start",
                                  width: "100%"
                                }}
                              >
                                <div 
                                  className={`opp-message-bubble ${emailItem.type === "sent" ? "sent" : "received"}`}
                                  style={{
                                    maxWidth: "80%",
                                    padding: "10px 15px",
                                    borderRadius: emailItem.type === "sent" ? "18px 18px 0 18px" : "18px 18px 18px 0",
                                    backgroundColor: emailItem.type === "sent" ? "#DCF8C6" : "#FFFFFF",
                                    boxShadow: "0 1px 1px rgba(0,0,0,0.1)",
                                    border: "1px solid #eee"
                                  }}
                                >
                                  {emailItem.isGrouped && (
                                    <div className="recipients">
                                      <strong>Recipients:</strong> <b>{emailItem.recipients.join(", ")}</b>
                                    </div>
                                  )}
                                  <p className="email-subject">
                                    <strong>Subject:</strong> {emailItem.subject}
                                  </p>
                                  {!emailItem.isGrouped && (
                                    <p className="email-receivers">
                                      <strong>To:</strong> {emailItem.receiver_email}
                                    </p>
                                  )}
                                  {emailItem.cc && (
                                    <p className="email-cc">
                                      <strong>CC:</strong> {emailItem.cc}
                                    </p>
                                  )}
                                  <div
                                    className="email-content"
                                    dangerouslySetInnerHTML={{ __html: cleanEmailText(emailItem.text) }}
                                  />
                                  {emailItem.file_path && (
                                    <a href={`${baseURL}${emailItem.file_path}`} target="_blank" rel="noopener noreferrer" className="attachment-link">
                                      📎 View Attachment
                                    </a>
                                  )}
                                  <div 
                                    className="timestamp" 
                                    style={{
                                      fontSize: "0.75rem",
                                      color: "#666",
                                      textAlign: emailItem.type === "sent" ? "right" : "left",
                                      marginTop: "5px"
                                    }}
                                  >
                                    {new Date(emailItem.created_at).toLocaleString()}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p>No email history available.</p>
                        )}

                        <div className="email-form" style={{ marginTop: "20px" }}>
                          <textarea
                            placeholder="Enter recipient emails (comma separated)"
                            value={receiverEmails}
                            onChange={(e) => setReceiverEmails(e.target.value)}
                            className="input-receivers"
                            style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
                          />
                          <div className="cc-bcc-toggle">
                            <label className="toggle-label">
                              <input
                                type="checkbox"
                                checked={showCC}
                                onChange={() => setShowCC(!showCC)}
                              />
                              Add CC
                            </label>
                            <label className="toggle-label">
                              <input
                                type="checkbox"
                                checked={showBCC}
                                onChange={() => setShowBCC(!showBCC)}
                              />
                              Add BCC
                            </label>
                          </div>

                          {showCC && (
                            <div className="form-group">
                              <label>CC:</label>
                              <textarea
                                placeholder="Enter CC emails (comma separated)"
                                value={ccEmails}
                                onChange={(e) => setCcEmails(e.target.value)}
                                className="input-receivers"
                              />
                            </div>
                          )}

                          {showBCC && (
                            <div className="form-group">
                              <label>BCC:</label>
                              <textarea
                                placeholder="Enter BCC emails (comma separated)"
                                value={bccEmails}
                                onChange={(e) => setBccEmails(e.target.value)}
                                className="input-receivers"
                              />
                            </div>
                          )}
                          <input
                            type="text"
                            placeholder="Enter Subject"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            className="input-subject"
                            style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
                          />
                          <ReactQuill
                            theme="snow"
                            value={text}
                            onChange={setText}
                            className="rich-text-editor"
                            style={{ marginBottom: "10px" }}
                          />
                          <input type="file" onChange={handleFileChange} className="file-input" />
                          <button
                            onClick={handleSendEmail}
                            disabled={loading}
                            className="send-button"
                            style={{ marginTop: "10px", padding: "10px 20px" }}
                          >
                            {loading ? "Sending..." : "Send Email"}
                          </button>
                        </div>
                      </div>
                    </Tab>
                  </Tabs>

                  <hr />

                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>Reminder Setting</Form.Label>
                      <Form.Control
                        type="datetime-local"
                        name="reminder_setting"
                        value={formData.reminder_setting}
                        onChange={handleChange}
                        min={new Date().toISOString().slice(0, 16)}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Notes</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="notes"
                        value={formData.notes}
                        onChange={handleChange}
                        rows={3}
                      />
                    </Form.Group>

                    <Button
                      className="mt-2 btn-warning text-white"
                      type="submit"
                    >
                      Submit Reminder
                    </Button>
                  </Form>

                  <div style={{ marginTop: "30px" }}>
                    <h5>Reminder History</h5>
                    <div 
                      className="reminder-history-list" 
                      style={{
                        maxHeight: "250px",
                        overflowY: "auto",
                        border: "1px solid #ddd",
                        borderRadius: "5px",
                        padding: "10px",
                        backgroundColor: "#f1f7ff",
                      }}
                    >
                      {reminderHistory.length > 0 ? (
                        reminderHistory.map((reminder, index) => (
                          <div 
                            key={reminder.id || index} 
                            style={{
                              padding: "10px",
                              borderBottom: index !== reminderHistory.length - 1 ? "1px solid #eee" : "none",
                              marginBottom: "8px",
                              position: "relative"
                            }}
                          >
                            <div style={{ 
                              fontSize: "0.85rem", 
                              color: "#6c757d",
                              marginBottom: "5px",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center"
                            }}>
                              <span>
                                <strong>Created:</strong>{" "}
                                {new Date(reminder.created_at).toLocaleString("en-IN", {
                                  timeZone: "Asia/Kolkata",
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit"
                                })}
                              </span>
                              {/* <FaTrash 
                                style={{ 
                                  cursor: "pointer", 
                                  color: "#dc3545",
                                  fontSize: "15px",
                                  transition: "opacity 0.2s"
                                }}
                                onClick={() => handleDeleteReminder(reminder.id, reminder.lead_id)}
                                title="Delete reminder"
                              /> */}
                            </div>
                            
                            <div style={{ 
                              fontSize: "0.95rem",
                              whiteSpace: "pre-line",
                              marginBottom: "5px"
                            }}>
                              <strong>Notes:</strong> {reminder.notes || "No notes"}
                            </div>
                            
                            <div style={{ 
                              fontSize: "0.95rem",
                              whiteSpace: "pre-line",
                              marginTop: "5px",
                              padding: "4px 8px",
                              borderRadius: "4px",
                              backgroundColor: reminder.action === "reminderdsss" ? "#cce5ff56" : "#e2e3e5",
                            }}>
                              <strong>Action:</strong> {reminder.action || "No action"}
                            </div>
                          </div>
                        ))
                      ) : (
                        <p style={{ textAlign: "center", color: "#6c757d", margin: "20px 0" }}>
                          No reminder history available
                        </p>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
            <Card.Footer className="s-LeadOppView-footer">
              <button
                className="btn btn-secondary"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
              <button
                className="btn btn-primary"
                onClick={() => handleEdit(lead.lead.leadid)}
              >
                Edit
              </button>
            </Card.Footer>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default LeadOppView;